var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPendent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.4585C16.8799 3.4585 20.835 7.41358 20.835 12.2935C20.835 17.1733 16.8799 21.1284 12 21.1284C7.12013 21.1284 3.16504 17.1733 3.16504 12.2935C3.16504 7.41358 7.12013 3.4585 12 3.4585ZM12 4.62842C7.76737 4.62842 4.33496 8.06083 4.33496 12.2935C4.33496 16.5261 7.76737 19.9585 12 19.9585C16.2326 19.9585 19.665 16.5261 19.665 12.2935C19.665 8.06083 16.2326 4.62842 12 4.62842ZM12.0049 7.30225C12.1627 7.29779 12.3106 7.33925 12.415 7.41943C12.5144 7.49585 12.585 7.61441 12.585 7.79346V12.4585H17.25C17.8007 12.4585 18.0225 12.7755 18.0225 13.0435C18.0225 13.3114 17.8007 13.6284 17.25 13.6284H11.415V7.79346C11.415 7.64077 11.4819 7.52556 11.5869 7.44287C11.6955 7.35737 11.8472 7.30673 12.0049 7.30225Z",
    fill: "#4F5660",
    stroke: "#4F5660",
    strokeWidth: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendent);
export default __webpack_public_path__ + "static/media/icon-pendent.43d4846b5cf6df7e58c00d7d592c016f.svg";
export { ForwardRef as ReactComponent };